import React from 'react';
import {getBaseURL} from "components/helpers/HostURLHelper.jsx";
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import AnalystTestsLOV from "./common/AnalystTestsLOV.jsx";
import qs from 'query-string';

import Button from '@material-ui/core/Button';
import brand_white from "assets/img/images/brand_white.png";

import { useURLParamsUpdater } from "./core/useURLParamsUpdater.js"

import DashboardIcon from '@material-ui/icons/Dashboard';

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    backgroundColor: '#223845'
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    //backgroundColor: "white",
    minHeight: "100vh"
  },
  logoutButton: {
    marginLeft: "auto"
  },
  yieldRoot: {
      padding: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
       padding: theme.spacing(4)
      },
    }
}));

function AnalystAppBar(props) {
  const { window, yieldComponent, component} = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const updateURLParams = useURLParamsUpdater();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const goToSection = (e,index) => {
    if(index == 0){
      props.history.push('/analysis/');
    }
    if(index == 1){
      props.history.push('/analysis/test/');
    }
    if(index == 2){
      props.history.push('/analysis/student/');
    }
  }


 const logoutUser =(e)=> {
    $.ajax({
      type: 'GET',
      url: getBaseURL() + '/global_users/sign_out'
    }).done((response, status, jqXHR)=>{
      sessionStorage.removeItem('as_username');
      sessionStorage.removeItem('as_isUserAnalyst');
      sessionStorage.removeItem('as_isUserMetaReadAdmin');
      sessionStorage.removeItem('user');
      props.history.push("/");
    }) 
  }


  const goBack = (e) => {
    e.preventDefault();
    const paper_id = qs.parse(props?.location?.search).paper_id;
    if(paper_id){
      props.history.push('/analysis/test?paper_id='+paper_id);

    } 
  }

  const onSelectSchedule = (option) => {
    updateURLParams({paper_id: option.paper_id});
	}

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        {['Dashboard', 'Test Reports', 'Student Reports'].map((text, index) => (
          <ListItem button key={text} onClick={(e) => goToSection(e,index)}>
            <ListItemIcon>{index === 0 ? <DashboardIcon/> : index % 2 != 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      {/*<Divider />
      <List>
        {['Cumulative Reports', 'Comparative Reports'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>*/}
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <img
            name="home"
            src={brand_white}
            style={{height: "60px"}}
          />
          {/*<Typography variant="h6" noWrap>
            Analysis
          </Typography>*/}
          <Button onClick={logoutUser} className={classes.logoutButton} color="inherit">Logout</Button>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden mdUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.yieldRoot}>
          {component == "test_report" &&
          <div style={{paddingBottom: "24px"}}>
            <Link 
            component="button"
            variant="body2" 
            onClick={goBack}
            >
            Back to Test Reports
          </Link>
          <div style={{paddingTop: "24px"}}>
            <AnalystTestsLOV {...props} onSelectSchedule={onSelectSchedule}/>
          </div>
          </div>
          }
          {yieldComponent}
        </div>
      </main>
    </div>
  );
}

AnalystAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default AnalystAppBar;
